@if (cardInfo(); as cardInfo) {
  <div>
    <crm-activity-rich-text [richText]="cardInfo.body"></crm-activity-rich-text>
  </div>
}
